(function(){
  var root = document.querySelector('[data-sf-root]');
  if(!root) return;
  var modal = root.querySelector('[data-sf-modal]');
  var ov = root.querySelector('[data-sf-ov]');
  var state = { data: null, size: null, idx: 0 };
  var scrollY = 0;

  function norm(s){ return (s || '').toString().trim().toLowerCase(); }
  function planId(){ return parseInt(state.data && state.data.plan, 10) || 0; }
  function onPlan(v){ var pid = planId(); if(!pid) return true; return !!(v && v.plans && v.plans.indexOf(pid) > -1); }
  function buyable(v){ return !!(v && v.ok && onPlan(v)); }
  function vFor(p){ var s = norm(state.size); for(var i=0;i<p.variants.length;i++){ if(norm(p.variants[i].title) === s) return p.variants[i]; } return null; }

  function stepTo(name){
    root.querySelectorAll('.sf-step').forEach(function(s){ s.classList.toggle('is-active', s.dataset.step === name); });
    modal.scrollTop = 0;
  }
  function lock(){
    scrollY = window.scrollY || window.pageYOffset;
    document.body.style.position='fixed'; document.body.style.top = (-scrollY)+'px';
    document.body.style.left='0'; document.body.style.right='0'; document.body.style.width='100%';
  }
  function unlock(){
    document.body.style.position=''; document.body.style.top='';
    document.body.style.left=''; document.body.style.right=''; document.body.style.width='';
    window.scrollTo(0, scrollY);
  }
  function open(){ modal.classList.add('is-open'); ov.classList.add('is-open'); lock(); }
  function close(){ modal.classList.remove('is-open'); ov.classList.remove('is-open'); unlock(); }

  root.querySelectorAll('[data-sf-close]').forEach(function(b){ b.addEventListener('click', close); });
  ov.addEventListener('click', close);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
  root.querySelectorAll('[data-sf-back]').forEach(function(b){ b.addEventListener('click', function(){ stepTo(b.dataset.sfBack); }); });

  function visible(){
    if(!state.data) return [];
    return state.data.products.filter(function(p){
      if(state.data.skipSale && p.onSale && p.onSale > 0) return false;
      return p.variants.some(buyable);
    });
  }

  root.querySelectorAll('[data-sf-pick]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var tag = root.querySelector('[data-sf-data="' + btn.dataset.sfPick + '"]');
      if(!tag) return;
      try { state.data = JSON.parse(tag.textContent); } catch(e){ return; }
      state.size = null; state.idx = 0;

      var sizes = (state.data.sizes || '').split(',').map(function(s){ return s.trim(); }).filter(Boolean);
      var wrap = root.querySelector('[data-sf-sizes]');
      wrap.innerHTML = '';
      sizes.forEach(function(sz){
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'sf-size'; b.textContent = sz;
        b.addEventListener('click', function(){
          state.size = sz;
          wrap.querySelectorAll('.sf-size').forEach(function(x){ x.classList.remove('is-on'); });
          b.classList.add('is-on');
          root.querySelector('[data-sf-sizeerr]').textContent = '';
          root.querySelector('[data-sf-tosize]').disabled = false;
        });
        wrap.appendChild(b);
      });
      root.querySelector('[data-sf-tosize]').disabled = true;
      root.querySelector('[data-sf-sizesub]').textContent = state.data.name;
      var g = root.querySelector('[data-sf-guide]');
      g.innerHTML = state.data.guide || '';
      root.querySelector('[data-sf-guidewrap]').style.display = state.data.guide ? '' : 'none';
      stepTo('size');
      open();
    });
  });

  root.querySelector('[data-sf-tosize]').addEventListener('click', function(){
    if(!state.size){ root.querySelector('[data-sf-sizeerr]').textContent = 'Pick a size first'; return; }
    var list = visible();
    if(!list.length){ root.querySelector('[data-sf-sizeerr]').textContent = 'No prints available on this membership right now'; return; }
    var sw = root.querySelector('[data-sf-swatches]');
    sw.innerHTML = '';
    list.forEach(function(p, i){
      var v = vFor(p), ok = buyable(v);
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'sf-sw';
      b.title = ok ? p.title : p.title + ' (not available in ' + state.size + ')';
      b.setAttribute('aria-label', b.title);
      if(!ok){ b.disabled = true; }
      var im = document.createElement('img');
      im.src = p.img; im.alt = p.title;
      b.appendChild(im);
      b.addEventListener('click', function(){ state.idx = i; paint(list); });
      sw.appendChild(b);
    });
    var first = -1;
    list.forEach(function(p, i){ if(first < 0 && buyable(vFor(p))) first = i; });
    state.idx = first < 0 ? 0 : first;
    root.querySelector('[data-sf-pairsub]').textContent = state.data.name + ' · size ' + state.size;
    paint(list);
    stepTo('pair');
  });

  function paint(list){
    var p = list[state.idx];
    if(!p) return;
    var shot = root.querySelector('[data-sf-shot]');
    shot.src = p.img; shot.alt = p.title;
    root.querySelector('[data-sf-shotname]').textContent = p.title;
    root.querySelector('[data-sf-was]').textContent = '$' + state.data.was;
    root.querySelector('[data-sf-now]').textContent = '$' + state.data.now + '/mo';
    root.querySelectorAll('[data-sf-swatches] .sf-sw').forEach(function(x, i){ x.classList.toggle('is-on', i === state.idx); });
    var v = vFor(p), ok = buyable(v);
    root.querySelector('[data-sf-add]').disabled = !ok;
    root.querySelector('[data-sf-adderr]').textContent = ok ? '' : (v && v.ok ? 'This print is not on the membership yet. Pick another.' : 'Sold out in ' + state.size + '. Pick another print.');
  }

  root.querySelector('[data-sf-add]').addEventListener('click', function(){
    var btn = this;
    var err = root.querySelector('[data-sf-adderr]');
    var list = visible();
    var p = list[state.idx];
    if(!p){ err.textContent = 'Pick a print first'; return; }
    var v = vFor(p);
    if(!buyable(v)){ err.textContent = 'That print is not available in ' + state.size; return; }
    var plan = planId();
    if(!plan){ err.textContent = 'This membership is not configured yet. Please contact us.'; return; }
    btn.disabled = true; err.textContent = '';
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1, selling_plan: plan }] })
    })
    .then(function(r){ return r.json().then(function(body){ return { ok: r.ok, body: body }; }); })
    .then(function(res){
      btn.disabled = false;
      if(!res.ok || res.body.status || res.body.errors){
        err.textContent = res.body.description || res.body.message || 'Could not add that to your cart. Try another print or size.';
        return;
      }
      close();
      if(typeof window.monster_refresh === 'function'){ try { window.monster_refresh(); } catch(e){} }
      window.location.href = window.Shopify.routes.root + 'cart';
    })
    .catch(function(){ btn.disabled = false; err.textContent = 'Network problem. Please try again.'; });
  });
})();
